import { UserSettingsComponent } from '../../components/user-settings';
import { getServerTranslations } from '../../lib/i18n/getServerTranslations';

const UserSettingsPage = () => {
  return <UserSettingsComponent />;
};

export const getStaticProps = async ({ locale }) => {
  const transConfig = await getServerTranslations(locale, ['common', 'user-settings']);
  return {
    props: {
      ...transConfig,
    },
  };
};

export default UserSettingsPage;
